import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/react";
import { Calendar as CalendarIcon } from "lucide-react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import CalendarPopoverPanel from "./CalendarPopoverPanel";

const cn = (...inputs) => twMerge(clsx(inputs));

const CommonDatePicker = ({
  value = null,
  onChange,
  placeholder = "dd/mm/yyyy",
  minDate = null,
  maxDate = null,
  disabled = false,
  width = "w-full",
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const formatDisplayDate = (dateValue) => {
    if (!dateValue) return "";

    try {
      const date = new Date(dateValue);

      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const handleConfirm = (dateString) => {
    onChange?.(dateString);
    setIsOpen(false);
  };

  const displayValue = formatDisplayDate(value);

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom-start"
      classNames={{
        content: "p-0 border-none shadow-lg",
      }}
    >
      <PopoverTrigger>
        <div
          tabIndex={disabled ? -1 : 0}
          className={cn(
            "flex items-center justify-between h-10 px-3 rounded-lg cursor-pointer transition-colors outline-none",
            width,
            disabled
              ? "border border-gray-200 dark:border-gray-800 bg-gray-100 dark:bg-gray-800 opacity-50 cursor-not-allowed"
              : cn(
                "border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm hover:bg-gray-50 dark:hover:bg-gray-800/80",
                isOpen
                  ? "border-secondary border-[1.5px]"
                  : "focus-within:border-secondary focus-within:border-[1.5px]",
              ),
            className,
          )}
        >
          <span
            className={`text-[0.715rem] font-inter font-medium truncate ${displayValue ? "text-gray-800 dark:text-gray-100" : "text-gray-400 dark:text-gray-400"
              }`}
          >
            {displayValue || placeholder}
          </span>

          <CalendarIcon
            size={16}
            className="text-gray-500 dark:text-gray-400 flex-shrink-0 cursor-pointer"
            strokeWidth={1.8}
          />
        </div>
      </PopoverTrigger>

      <PopoverContent>
        <CalendarPopoverPanel
          value={value}
          minDate={minDate}
          maxDate={maxDate}
          onConfirm={handleConfirm}
          onCancel={() => setIsOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
};

export default CommonDatePicker;
